import { useQuery } from '@tanstack/react-query'
import {
  fetchElitePrimeSummaryStatus,
  fetchOnboardingAdvisoryStatusV2,
  selectEliteOnboardingFromAdvisoryAxios
} from '../../../repository/misc'
import type { EliteOnboardingStatusResponse } from '../../../types/misc.types'
import { ELITE_PLANS_ELITE_PRIME_TAB_ID } from '../constants/planIds'
import { ELITE_PLANS_LANDING_STATUS_QUERY_KEY } from '../constants/queryKeys'

async function fetchStatusForPlan(planId: string): Promise<{ data?: unknown }> {
  const response =
    planId === ELITE_PLANS_ELITE_PRIME_TAB_ID
      ? await fetchElitePrimeSummaryStatus()
      : await fetchOnboardingAdvisoryStatusV2()
  // Backend can return 2xx with an error envelope — surface it as a query error so pages show the error screen
  if (!selectEliteOnboardingFromAdvisoryAxios(response as { data?: unknown })) {
    throw new Error('Invalid elite plans status response')
  }
  return response as { data?: unknown }
}

export function useElitePlansStatus(planId: string, queryKeyRoot = ELITE_PLANS_LANDING_STATUS_QUERY_KEY) {
  return useQuery<{ data?: unknown }, Error, EliteOnboardingStatusResponse | undefined>({
    queryKey: [queryKeyRoot, planId],
    queryFn: () => fetchStatusForPlan(planId),
    select: selectEliteOnboardingFromAdvisoryAxios,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: Boolean(planId)
  })
}
